// Ana sayfa "Günlük Görev Durumu Dağılımı" pasta grafiği rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'dashboard.taskStatus';

export const taskStatusGuide = (t: TFunction): GuideContent => ({
  layout: 'chart',
  title: t(`${G}.title`, 'Günlük Görev Durumu Dağılımı nasıl okunur?'),
  intro: t(`${G}.intro`, 'Bu grafik, günlük görevlerin durumlarına göre dağılımını gösterir. Her dilim bir durumdur; dilimin büyüklüğü o durumdaki görev sayısıdır. Altındaki açıklamada her durumun toplamdaki yüzdesi yazar, dilimin üzerine gelince görev sayısını görürsünüz. Sayısı sıfır olan durumlar grafikte görünmez.'),
  chart: {
    kind: 'pie',
    legend: [
      { color: '#4CAF50', label: t(`${G}.l1.label`, 'Tamamlanan'), text: t(`${G}.l1.text`, 'Başarıyla tamamlanan görevlerin sayısı. Görev listesinde tamamlandı olarak işaretlenen görevlerle geçmişte kaydedilen tamamlanma kayıtları birlikte sayılır.') },
      { color: '#1976D2', label: t(`${G}.l2.label`, 'Devam Eden'), text: t(`${G}.l2.text`, 'Personele atanmış veya personel tarafından kabul edilmiş, çalışması devam eden görevlerin sayısı.') },
      { color: '#2196F3', label: t(`${G}.l3.label`, 'Bekleyen'), text: t(`${G}.l3.text`, 'Henüz başlanmamış, sırasını bekleyen görevlerin sayısı.') },
      { color: '#FF9800', label: t(`${G}.l4.label`, 'Bekliyor'), text: t(`${G}.l4.text`, 'Beklemeye alınmış, işlem bekleyen görevlerin sayısı.') },
      { color: '#F44336', label: t(`${G}.l5.label`, 'Tamamlanmamış'), text: t(`${G}.l5.text`, 'Süresi geçtiği halde tamamlanmamış (kaçırılan) görevlerin sayısı.') },
    ],
    note: t(`${G}.note`, 'Şube yöneticisi olarak giriş yaptıysanız grafik yalnız kendi şubenizin görevlerini gösterir.'),
  },
});
